import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import constants from "../../../constants";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const AddStaffButton = ({
  officeId,
  location,
  variant = "link",
  t,
  globalStaffPage,
}) => {
  const { selectedId,selectedOwnerIdString } = useAccountOwnerCommon();
  const linkProps = {
    to: {
      pathname: globalStaffPage
        ? constants.routes.globalStaffAdd
        : constants.routes.accountOwner.addStaff.replace(":id", officeId),
      state: {
        officeData: location?.state?.officeData || {},
        ownerId: selectedId,
      },
      search:globalStaffPage&&selectedOwnerIdString?`?${selectedOwnerIdString}`:""
    },
    title: t("accountOwner.addStaff"),
  };

  if (variant === "link") {
    return (
      <Link
        {...linkProps}
        className="button button-round button-width-large add-button"
      >
        {t("accountOwner.addStaff")}
      </Link>
    );
  }

  return (
    <Link {...linkProps}>
      <button
        className="button button-round button-border button-dark"
        title={t("accountOwner.addStaff")}
      >
        {t("accountOwner.addStaff")}
      </button>
    </Link>
  );
};

export default withTranslation()(AddStaffButton);
